/*
 * S6 (design-uplift r1) — theme-source resolution.
 *
 * A SAVED server preference (an explicit boolean `darkTheme` on the user's
 * preference record) always wins — a user who chose light or dark keeps it. When
 * NO saved preference exists (the field is absent / the record is nullish), fall
 * back to the OS appearance via `prefers-color-scheme`, so a device in Dark Mode
 * is served dark by default instead of always-light (iOS HIG expectation).
 *
 * This does NOT persist anything and does NOT override a saved choice; it only
 * changes the DEFAULT when the user has never expressed one.
 */

export const prefersDarkScheme = () => {
  try {
    return (
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches
    );
  } catch (e) {
    return false;
  }
};

// Returns 'dark' | 'light'. A saved boolean wins; otherwise the OS appearance.
export const resolveInitialTheme = (userPreferenceData) => {
  const saved = userPreferenceData?.darkTheme;
  if (typeof saved === 'boolean') return saved ? 'dark' : 'light';
  return prefersDarkScheme() ? 'dark' : 'light';
};

// Keep the <body> theme class in sync so the round-1 design tokens
// (src/styles/design-tokens-r1.css) resolve their dark values. The existing
// per-property switcher (setProperty on document.body) still runs alongside this.
export const syncThemeBodyClass = (newTheme) => {
  if (typeof document !== 'undefined' && document.body) {
    document.body.classList.toggle('qln-theme-dark', newTheme === 'dark');
  }
};
